import React, { Component } from 'react';
import './App.css';
import TourSlide from './TourSlide';
import StepCounter from './StepCounter';
import { ThreeBounce } from 'better-react-spinkit';
import axios from 'axios';
import { Preload } from 'react-preload';


const redirectUrlOnEnd = 'https://www.upress.io/prices';
const upressLogoUrl = 'https://www.upress.io/themes/upress/assets/img/logo.png';


export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 0,
      tour: [],
      isLoading: true,
      isError: false
    };
  }

  componentDidMount() {
    this.setupTour();
  }

  onImagePreloadError() {
    this.setState({isLoading: false, isError: true})
  }

  onImagePreloadSuccess() {
    this.setState({isLoading: false, isError: false})
  }

  setupTour() {
    axios.get('/tour.json')
      .then(results => {
        this.setState({
          tour: results.data,
          isLoading: false
        })
      })
      .catch(error => {
        console.error(error);
        this.onImagePreloadError(); // FIXME: add error message?
      });
  }

  doPrevStep() {
    this.setState({
      currentStep: Math.max(0, Math.max(0, this.state.currentStep - 1))
    })
  }
  doNextStep() {
    this.setState({
      currentStep: Math.min(this.state.tour.length - 1, this.state.currentStep + 1)
    })
  }

  doFinishStep() {
    window.location.href = redirectUrlOnEnd;
  }


  render() {
    let loader = <div className="Tour__loader"><ThreeBounce color="#1489c9" size={35} /></div>;
    if (this.state.isLoading) {
      return loader;
    }

    if (this.state.isError) {
      return <p>Unexpected Error.</p>;
    }

    let slide = this.state.tour[this.state.currentStep];

    return (
      <Preload
        loadingIndicator={loader}
        images={this.state.tour.map(item => '/assets/' + item.image)}
        onError={this.onImagePreloadError.bind(this)}
        onSuccess={this.onImagePreloadSuccess.bind(this)}
        autoResolveDelay={10000}
        resolveOnError={true}
        mountChildren={true}
      >
        <div className="Tour">
          <StepCounter currentStep={this.state.currentStep + 1} totalSteps={this.state.tour.length} />

          <TourSlide
            currentStep={this.state.currentStep + 1}
            maxSteps={this.state.tour.length}

            image={slide.image}
            title={slide.title}
            content={slide.content}
            highlightPosX={slide.highlight.x}
            highlightPosY={slide.highlight.y}
            highlightWidth={slide.highlight.width}
            highlightHeight={slide.highlight.height}
            textPosX={slide.text.x}
            textPosY={slide.text.y}
            textWidth={slide.text.width}
            textHeight={slide.text.height}

            hasNextButton={this.state.currentStep < this.state.tour.length - 1}
            hasPrevButton={this.state.currentStep > 0}
            hasFinishButton={this.state.currentStep === this.state.tour.length - 1}
            finishUrl={redirectUrlOnEnd}
            doNextStep={this.doNextStep.bind(this)}
            doPrevStep={this.doPrevStep.bind(this)}
            doFinishStep={this.doFinishStep.bind(this)}

            logoUrl={upressLogoUrl}
            displayLogo={this.state.currentStep === 0 || this.state.currentStep === this.state.tour.length - 1}
          />
        </div>
      </Preload>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js